import { BooleanInput, FormDataConsumer, NumberInput, TextInput, maxValue, minValue, usePermissions } from 'react-admin';
import { Grid } from '@mui/material';
import { IntegrationType } from '../models';
import { PERMISSIONS } from '../constants';

const WEBHOOK_HELP =
  'Na Sislav, cadastre o webhook com a URL https://sales-api.pontuax.com.br/v1/webhooks/sislav e os eventos Venda aprovada e Cliente cadastrado';

// Credenciais da Sislav (posto e parceiro). Só aparecem com a integração Sislav.
// Chave e token são `select: false` no backend e o PATCH dá 403 para quem não tem a
// permissão da aba Sincronização (placeSecrets.ts), então só essa permissão vê os dois.
export const SislavFields = () => {
  const { permissions } = usePermissions();
  const canEditSecrets = !!permissions?.includes(PERMISSIONS.REGISTER_STATION_SYNCHONIZATION);
  return (
    <FormDataConsumer>
      {({ formData }) => formData.integration === IntegrationType.sislav && (
        <>
          {canEditSecrets && (
            <Grid size={{ xs: 12, md: 4 }}>
              <TextInput label="Chave da API Sislav" source="sislavApiKey" />
            </Grid>
          )}
          <Grid size={{ xs: 12, md: 4 }}>
            <TextInput label="ID da unidade na Sislav" source="sislavLaundryId" />
          </Grid>
          {canEditSecrets && (
            <Grid size={{ xs: 12, md: 4 }}>
              <TextInput label="Token do webhook" source="sislavWebhookToken" helperText={WEBHOOK_HELP} />
            </Grid>
          )}
        </>
      )}
    </FormDataConsumer>
  );
};

// Chave e token só viajam quando a integração é Sislav e alguém digitou um valor: qualquer
// presença deles no payload (até null) exige a permissão de Sincronização no backend, e
// campo vazio aqui é credencial que não veio no GET, não pedido de apagar.
export const clearSislavFields = (data: any) => {
  const isSislav = data.integration === IntegrationType.sislav;
  if (!isSislav) { data.sislavLaundryId = null; }
  for (const field of ['sislavApiKey', 'sislavWebhookToken']) {
    if (!isSislav || data[field] === undefined || data[field] === null || data[field] === '') {
      delete data[field];
    }
  }
  return data;
};

// Campos do produto (aba Resgate) para um local com integração Sislav.
export const SislavProductFields = () => (
  <>
    <NumberInput
      source="sislavDiscountPercentage"
      label="Desconto na lavanderia (%)"
      helperText="100 = lavagem grátis"
      validate={[minValue(1), maxValue(100)]}
      min={1}
      max={100}
      sx={{ width: 200 }}
    />
    <BooleanInput label="Vale em lavadora" source="sislavOnWasher" defaultValue sx={{ alignSelf: 'center' }} />
    <BooleanInput label="Vale em secadora" source="sislavOnDryer" defaultValue sx={{ alignSelf: 'center' }} />
  </>
);

// Fora da Sislav: percentual nulo e as duas máquinas ligadas (default da coluna).
export const sislavPlaceFields = (isSislav: boolean, place: any) => ({
  sislavDiscountPercentage: isSislav ? (place.sislavDiscountPercentage ?? null) : null,
  sislavOnWasher: isSislav ? (place.sislavOnWasher ?? true) : true,
  sislavOnDryer: isSislav ? (place.sislavOnDryer ?? true) : true,
});
